import { collectCss } from '../../../../../../../internal/style-injector/src/index.mjs';

var css = ".PasskeyRegistrationSuccess_module_existing__75ecfc0f{border-top:1px solid var(--st-border)}.PasskeyRegistrationSuccess_module_passkeyRow__75ecfc0f{border-bottom:1px solid var(--st-border)}";
collectCss(css);
var modules_04e642ad = {"existing":"PasskeyRegistrationSuccess_module_existing__75ecfc0f","passkeyRow":"PasskeyRegistrationSuccess_module_passkeyRow__75ecfc0f"};

export { css, modules_04e642ad as default };
//# sourceMappingURL=PasskeyRegistrationSuccess.module.css.mjs.map
